import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import HomeSectionFrame from './HomeSectionFrame';

const StudySupportBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <HomeSectionFrame
      id="study-support"
      aria-labelledby="study-support-heading"
      tone="ink"
      innerClassName="!py-7 sm:!py-8 lg:!py-9"
    >
      <div className="relative z-[1] flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
        <div className="relative min-w-0 max-w-xl space-y-2">
          <h2
            id="study-support-heading"
            className="text-xl font-extrabold leading-snug text-white sm:text-2xl"
          >
            مش مجرد فيديوهات
          </h2>
          <p className="text-sm leading-relaxed text-white/85 sm:text-[0.95rem] sm:leading-7">
            تابع تقدمك واختبر فهمك من جوه المنصة.
          </p>
        </div>
        <ul className="relative flex flex-wrap gap-x-5 gap-y-2.5" aria-label="إمكانيات الدعم الدراسي">
          <li className="inline-flex min-h-8 items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1.5">
            <TrendingUp className="h-5 w-5 text-brand-300" aria-hidden />
            <span className="text-sm font-semibold text-white">متابعة التقدم</span>
          </li>
        </ul>
        <div className="relative shrink-0 lg:ps-2">
          <button
            type="button"
            onClick={() => navigate(isAuthenticated ? '/student-portal' : '/register')}
            className="inline-flex min-h-[46px] w-full items-center justify-center rounded-xl border-2 border-white bg-white px-5 py-2.5 text-sm font-semibold text-slate-900 transition hover:bg-brand-50 sm:w-auto sm:text-base"
          >
            ابدأ دلوقتي
          </button>
        </div>
      </div>
    </HomeSectionFrame>
  );
};

export default StudySupportBanner;
